import { Alert, Link, Typography } from '@mui/material'
import { FC } from 'react'
import { useTodoOffersQuery } from '~/generated/graphql'
import { pagesPath } from '~/lib/$path'
import NextLink from 'next/link'

export const TodoOfferAlert: FC = () => {

  const { data, loading, error } = useTodoOffersQuery()

  if (loading || error) return null

  const todoOffersCount = data?.viewer.company?.todoOffers?.length ?? 0

  if (todoOffersCount === 0) return null

  return (
    <Alert
      severity="warning"
    >
      <Link
        component={NextLink}
        href={pagesPath.offers.$url()}
        sx={{
          textDecoration: 'underline',
          '&:hover': {
            textDecoration: 'underline',
          },
          color: 'inherit',
        }}
      >
        <Typography variant="labelMJpNormalMedium" color="warning.160p">
          対応が必要なやりとりがあります
        </Typography>
      </Link>
    </Alert>
  )
}
